import React, { memo } from 'react';
import { FadeIn } from './Shared';
import { XCircle } from 'lucide-react';
export const PainSection = () => {
  const pains = ['Separaste un producto para una clienta que dijo "mañana te transfiero la seña". Nunca transfirió. Nunca retiró. El producto lleva tres semanas ocupado para nadie.', 'Una clienta te dice "ya te transferí" y vos buscás en el banco, en Mercado Pago, en los chats, en las capturas. No encontrás nada. ¿Le entregás o no le entregás?', 'Vendiste todo el fin de semana. Entraron transferencias, señas, pagos en efectivo. El lunes no sabés cuánto cobré, qué falta cobrar ni qué pedidos quedan abiertos.', 'Tenés pedidos anotados en 12 chats distintos. Uno en WhatsApp personal. Otro en el DM de Instagram. Otro en un papelito que no encontrás. Otro en la memoria.', 'Le mandaste el talle equivocado porque armaste el pedido de memoria con tres pedidos abiertos al mismo tiempo.', 'Vendiste por Instagram algo que ya habías separado para otra clienta en el showroom. Dos ventas. Un producto. Un problema.', 'Trabajaste todo el mes. Compraste stock, vendiste, cobraste. Pero si alguien te pregunta cuánto ganaste, no sabés qué contestar.'];
  return <section className="py-16 md:py-24 px-4 bg-navy-900/50 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-218">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_100%,rgba(236,72,153,0.03),transparent_70%)] pointer-events-none" data-id="element-219"></div>
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-220">
        <FadeIn data-id="element-221">
          <h2 className="text-3xl md:text-5xl text-white mb-10 text-center leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-222">
            ¿Cuánta plata más vas a perder <br className="hidden md:block" data-id="element-223" />
            <span className="text-pink-400" data-id="element-224">por no tener un sistema?</span>
          </h2>

          <div className="mx-auto mb-12 text-gray-200 text-center space-y-6 text-base md:text-lg font-sans opacity-95 leading-relaxed" data-id="element-225">
            <p data-id="element-226">
              Sos una emprendedora que trabaja todo el día. Respondés mensajes,
              separás productos, coordinás entregas, cobrás transferencias,
              mandás comprobantes, contestás consultas de Instagram.
            </p>
            <p data-id="element-227">
              Trabajás sin parar. Y aun así, el domingo a la noche mirás el
              saldo de la cuenta y pensás:
            </p>
            <p className="text-xl md:text-2xl font-bold text-white italic" data-id="element-228">
              "¿Dónde está la plata?"
            </p>
            <p data-id="element-229">No desapareció. Está escondida en el desorden.</p>
          </div>

          <div className="bg-navy-900/60 border border-white/10 rounded-3xl p-6 md:p-10 mb-12" data-id="element-230">
            <ul className="space-y-6" data-id="element-231">
              {pains.map((pain, index) => <li key={index} className="flex items-start" data-id="element-232">
                  <XCircle className="w-5 h-5 md:w-6 md:h-6 text-pink-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-233" />
                  <span className="text-base md:text-lg text-gray-100 font-sans leading-relaxed" data-id="element-234">
                    {pain}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="flex justify-center mb-12" data-id="element-235">
            <div className="bg-gradient-to-r from-pink-500/10 via-pink-500/20 to-pink-500/10 border-y border-pink-500/30 py-6 px-8 w-full max-w-2xl text-center" data-id="element-236">
              <p className="font-bold text-white uppercase tracking-[0.15em] text-lg md:text-2xl font-sans leading-snug" data-id="element-237">
                El problema no es que vendés poco.
                <br className="md:hidden" data-id="element-238" />{' '}
                <span className="text-pink-400" data-id="element-239">
                  El problema es que perdés plata que ya tenías por falta de
                  sistema.
                </span>
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-240">
            <h3 className="text-xl md:text-3xl text-gray-300 leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-241">
              Y eso tiene solución. Una solución práctica, simple y lista para
              aplicar hoy.
            </h3>
          </div>
        </FadeIn>
      </div>
    </section>;
};